
import Fly from 'flyio/dist/npm/fly'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'

import LandingPageHeaderKol from '@/components/LandingPageHeaderKol'
import LandingPageFooter from '@/components/LandingPageFooter'
import LandingPageFooterKol from '@/components/LandingPageFooterKol'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'
import {authRegister} from '@/api/user'

export default {
components: {
XButton,
Box,
Flexbox,
FlexboxItem,
LandingPageHeaderKol,
LandingPageFooter,
LandingPageFooterKol,
IndexSidebar,
IndexFooter,
XInput,
Group,
Toast
},
data () {
return {
loginModel: {
mobile: '',
password: '',
identity: 'advertiser',
captcha: '',
msgcode: '',
captcha_token: '',
device: 'wap'
},
loginModel2: {
mobile: '',
password: '',
identity: 'advertiser',
captcha: '',
msgcode: '',
captcha_token: '',
device: 'wap'
},
getTextCode: '获取验证码',
captchaImg: '/static/images/vcode.jpg',
smsCount: 0,
smsDisable: false,
scrollTop: 0,
tabIndex: 0,
woakol: [{
avatar: 'https://wx.qlogo.cn/mmhead/Q3auHgzwzM5SUtLag6HZn4E3Sqnmfqj11pDjia1V63wHKpzvNVicukicA/0',
name: '她街拍',
fansnum: '160万',
price: '¥120000'
},
{
avatar: 'https://static.xinmeibao.com/uploads/000000/180627/5a15a04862c0e.png',
name: '十点读书会',
fansnum: '155万',
price: '¥83369 '
},
{
avatar: 'https://static.xinmeibao.com/face/woa/20180913144550NAZJUg.jpg?x-oss-process=image/crop,x_173,y_173,w_82,h_82',
name: '有格',
fansnum: '305万',
price: '¥120000'
},
{
avatar: 'https://static.xinmeibao.com/uploads/000000/180627/5a16dd3eb95a5.png',
name: '不二大叔',
fansnum: '330万',
price: '¥150000'
}
],
weibokol: [{
avatar: 'http://tva3.sinaimg.cn/crop.0.0.750.750.180/9d02006bjw8f3jt6jndtmj20ku0ku3zo.jpg',
name: '虫虫Chonny',
fansnum: '334.18万',
price: '¥136800'
},
{
avatar: 'http://tvax2.sinaimg.cn/crop.0.10.1125.1125.180/006q8szCly8fgq42km241j30v90vtq6j.jpg',
name: 'Pony__朴惠敏',
fansnum: '707.16万',
price: '¥250800 '
},
{
avatar: 'http://tvax4.sinaimg.cn/crop.0.0.512.512.180/0065Ippvly8fsmie45toej30e80e875l.jpg',
name: '温婉Wenwan_',
fansnum: '270.52万',
price: '¥242000'
},
{
avatar: 'http://tvax2.sinaimg.cn/crop.14.0.722.722.180/006USit1ly8fkz1xw8g57j30ku0k2ab5.jpg',
name: '七舅脑爷',
fansnum: '198.02万',
price: '¥137800'
}
],
xhskol: [{
avatar: 'https://static.xinmeibao.com/assets_web/img/5d4a8ad5d4f65690dccf08ee0d63bd30.jpg',
name: 'Ritatawang',
fansnum: '344.92万',
price: '¥154000'
},
{
avatar: 'https://static.xinmeibao.com/assets_web/img/ecf6e7190e6c058a3306f30f216d4920.jpg',
name: '大睿睿',
fansnum: '190.17万',
price: '¥114950 '
},
{
avatar: 'https://static.xinmeibao.com/assets_web/img/7b3c3c1c5c14732d05511d84155600d3.jpg',
name: '周韦彤Cica',
fansnum: '1.72万',
price: '¥192390'
},
{
avatar: 'https://static.xinmeibao.com/assets_web/img/043fb1bbfa1a08c4a60f4f993ec52ca7.jpg',
name: '吉克隽逸',
fansnum: '37.93万',
price: '¥230000'
}
],
videokol: [{
avatar: 'https://static.xinmeibao.com/uploads/1/180904/258069659aae4fd58582a6d8bfff0171.jpg',
name: '小黎喵7',
fansnum: '29万',
price: '¥10769'
},
{
avatar: 'https://static.xinmeibao.com/uploads/000000/180615/592bfd5a2b3d01316.jpg',
name: '最热视频精选',
fansnum: '17万',
price: '¥762 '
},
{
avatar: 'https://static.xinmeibao.com/uploads/000000/180615/BMjAxODA1MTEyMzM5NTBfNjYzMDUzNjlfMV9oZDk0OV81ODY=_s.jpg',
name: '叫我小马林🔥',
fansnum: '147万',
price: '¥455444'
},
{
avatar: 'https://static.xinmeibao.com/uploads/000000/180627/5a16dd3eb95a5.png',
name: '微在不懂爱',
fansnum: '81万',
price: '¥150000'
}
],
livekol: [{
avatar: 'https://static.xinmeibao.com/uploads/000000/180614/1b3f8354c927659291b90e4f02c2814c.jpg',
name: '陈老师-陈思雨',
fansnum: '23万',
price: '¥7139'
},
{
avatar: 'https://static.xinmeibao.com/uploads/000000/180614/42401b2a3d009de1087df7eda218544c.jpg',
name: '尤马马',
fansnum: '88万',
price: '¥24684 '
},
{
avatar: 'https://static.xinmeibao.com/uploads/000003/3d1fc859de3096b6147d31e2716b21d7.jpg',
name: 'Reginachenchen',
fansnum: '226.6万',
price: '¥9680'
},
{
avatar: 'https://static.xinmeibao.com/uploads/000000/180614/fb75a7c8b0b1b886b39f6ace01bff195.jpg',
name: '兔牙妹199',
fansnum: '71万',
price: '¥7502'
}
],
tabIndexKol: '0',
tabIndexPar: '0',
financeImgList: [
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/爱钱进.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/百度有钱花.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/凤凰金融.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/金银猫.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/京东金融.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/你我贷.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/平安银行.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/浦发银行.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/finance/钱多多.png'}
],
itImgList: [
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/boss直聘.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/爱回收.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/爱奇艺.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/薄荷阅读.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/京东.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/每日优鲜.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/苏宁.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/天天P图.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/it/网易严选.png'}
],
technologyImgList: [
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/3M.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/OPPO.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/vivo.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/百度.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/大疆无人机.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/戴尔.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/飞利浦.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/华为.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/technology/佳能.png'}
],
carImgList: [
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/奥迪.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/宝马.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/奔驰.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/吉利.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/捷豹.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/凯迪拉克.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/雷克萨斯.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/路虎.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/car/沃尔沃.png'}
],
educationImgList: [
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/VIPKID.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/哒哒英语.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/环球雅思.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/金吉列留学.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/尚德机构.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/星火教育.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/学而思.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/英孚教育.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/education/英语流利说.png'}
],
fashioneImgList: [
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/Dior.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/FARFETCH.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/HM.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/HUGOBOSS.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/Lamer.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/YSL.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/纪梵希.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/丝芙兰.png'},
{'imgSrc': 'https://static.xinmeibao.com/assets_mobile/partners/fashion/雅诗兰黛.png'}
]
}
},
methods: {

getCaptcha () {
let fly = new Fly() 
fly.config.withCredentials = true  
fly.request('https://api.ruan.net/api/auth/captcha/generate', {}, {
method: 'post'
}).then(resp => {
this.captchaImg = resp.data.data.src
this.loginModel.captcha_token = resp.data.data.captcha_token
this.loginModel2.captcha_token = resp.data.data.captcha_token
}).catch((e) => console.log('error', e))
},

getTextCaptcha (type) {
if (!this.smsDisable) {
if (type === 2) {
if (!this.loginModel2.captcha) {
this.$vux.toast.show({
text: '请输入正确的验证码',
time: 1000
})
this.getCaptcha()
return false
} else if (!this.loginModel2.mobile) {
this.$vux.toast.show({
text: '请输入手机号',
time: 1000
})
return false
}
} else {
if (!this.loginModel.captcha) {
this.$vux.toast.show({
text: '请输入正确的验证码',
time: 1000
})
this.getCaptcha()
return false
} else if (!this.loginModel.mobile) {
this.$vux.toast.show({
text: '请输入手机号',
time: 1000
})
return false
}
}

const textCaptchaModel = type === 2
? {
captcha: this.loginModel2.captcha,
captcha_token: this.loginModel2.captcha_token,
mobile: this.loginModel2.mobile,
scope: 'mobile_signup'
}
: {
captcha: this.loginModel.captcha,
captcha_token: this.loginModel.captcha_token,
mobile: this.loginModel.mobile,
scope: 'mobile_signup'
}
let fly = new Fly() 
fly.request('https://api.ruan.net/api/auth/captcha/sms', textCaptchaModel, {
method: 'post'
}).then(resp => {
if (!resp.data.success) {
this.getCaptcha()
} else {
this.smsCountDown()
}
this.$vux.toast.show({
text: resp.data.message,
time: 1000
})

}).catch((e) => console.log('获取短信验证码失败', e))
}
},

smsCountDown () {
const _this = this
_this.smsCount = 60
_this.smsDisable = true
let interval = window.setInterval(function () {
--_this.smsCount
if (_this.smsCount === 0) {
_this.smsDisable = false
window.clearInterval(interval)
}
}, 1000)
},


login (type) {

const password = Math.random().toString().substr(2).slice(0, 6)

const registerModel = type === 2 ? {
mobile: this.loginModel2.mobile,
password,
identity: 'advertiser',
captcha: this.loginModel2.captcha,
captcha_token: this.loginModel2.captcha_token,
captcha_sms: this.loginModel2.msgcode,
scope: 'mobile_signup',
device: 'wap'
} : {
mobile: this.loginModel.mobile,
password,
identity: 'advertiser',
captcha: this.loginModel.captcha,
captcha_token: this.loginModel.captcha_token,
captcha_sms: this.loginModel.msgcode,
scope: 'mobile_signup',
device: 'wap'
}
authRegister(registerModel).then(res => {
this.$vux.toast.show({
text: res.message,
time: 1000
})
this.$router.push('/media')
}).catch((e) => {
console.log('注册失败', e)
this.$vux.toast.show({
text: e.message,
type: 'cancel',
time: 2000
})
this.getCaptcha()
this.loginModel.captcha = ''
this.loginModel2.captcha = ''
})
},
goAnchor (selector) {
console.log(this.$parent.$parent.$refs.viewBox.scrollTo)
var anchor = this.$el.querySelector(selector)

this.$parent.$parent.$refs.viewBox.scrollTo(anchor.offsetTop - 100)
},

changeTab (index) {
this.tabIndex = index
},

changeKolTab (index) {
this.tabIndexKol = index
},
changePartnersTab (index) {
this.tabIndexPar = index
}
},
mounted () {
this.getCaptcha()
}
}



// WEBPACK FOOTER //
// ./src/pages/newguestkol/index.vue